import script from "./Features.vue?vue&type=script&setup=true&lang=js"
export * from "./Features.vue?vue&type=script&setup=true&lang=js"

import "./Features.vue?vue&type=style&index=0&id=28abca0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28abca0f"]])

export default __exports__